<div class="eligibility-screen">
    <p-dialog [(visible)]="showDialog" [modal]="true" (onHide)="goToHome()" [closable]="!(status.aa || status.isEligiblity || status.isProcessed)" styleClass="cus-dialog-lg cus-dialog dark-dialog"
        [draggable]="false" [resizable]="false">
        <!-- Eligibility Check 1 -->
        <div *ngIf="status.isEligiblity || status.isProcessed" class="dark-content eligibility-dialog">
            <div class="dark-inner">
                <div class="gradient-line"></div>
                <div class="dark-left">
                    <ng-lottie [options]="options"></ng-lottie>
                </div>
                <div class="dark-right">
                    <div class="dark-inn-title"><span class="highlight">Checking </span> <span class="wrap-text">your
                            Eligibility</span></div>
                    <div class="dark-inn-info">This will take just a moment.</div>
                </div>
            </div>
        </div>
        <!-- AA Flow -->
        <div *ngIf="status.aa" class="dark-content eligibility-dialog">
            <div class="dark-inner">
                <div class="gradient-line"></div>
                <div class="dark-left">
                    <ng-lottie [options]="options"></ng-lottie>
                </div>
                <div class="dark-right">
                    <div class="dark-inn-title"><span class="wrap-text">We require more data
                         </span> <span class= "highlight">to check your eligibility</span></div>
                    <div class="dark-inn-info">This will take just a moment.</div>
                </div>
            </div>
        </div>

        <!-- Eligibility Check 2 -->
        <ng-container  *ngIf="status.isTermLoan"
        >
        <app-terms [tenureData]="tenureData" (selectTerm)="selectTerm($event)"></app-terms>
    </ng-container>
      

        <!-- Eligibility Check 3 -->
        <div *ngIf="status.success" class="dark-content eligibility-dialog success">
            <div class="dark-inner">
                <div class="gradient-line"></div>
                <div class="dark-left">
                    <ng-lottie [options]="successOption"></ng-lottie> 
                </div>
                <div class="dark-right">
                    <div class="dark-inn-title">Congrats! Your loan of<span class="wrap-text"><span class="highlight">
                                ₹{{formator.format(selectedTenure.amount)}}
                            </span>has been</span> sanctioned successfully!</div>
                </div>
            </div>
        </div>
        <!-- Waiting Screen -->
        <div *ngIf="status.iswaiting" class="dark-content selfie-dialog">
            <div class="dark-inner">
                <div class="gradient-line"></div>
                <div class="dark-left">
                    <ng-lottie [options]="options"></ng-lottie>
                </div>
            
                
                <!-- Optional Deviation Content 2-->
                <div class="dark-right">
                    <div class="dark-inn-title">Please give us a <span class="highlight-secondary wrap-text">little more
                            time</span></div>
                    <div class="dark-inn-info">Thank you for choosing us. Your loan <span
                            class="wrap-text">eligibility is being calculated. We will notify</span> you as soon as we can.</div>
                    <button class="btn-theme" (click)="goToHome();showDialog = false">Back to Home</button>
                </div>
            </div>
        </div>

        <!-- Rejected -->
        <div *ngIf="status.isRejected" class="dark-content selfie-dialog">
            <div class="dark-inner">
                <div class="gradient-line"></div>
                <div class="dark-left">
                    <img [src]="warnImage" alt="Loader Image" />
                </div>
                <div class="dark-right">
                    <div class="dark-inn-title reject-title"><span class="highlight">Uh-oh, <span
                                class="wrap-text">please start over</span></span></div>
                    <div class="dark-inn-info">It seems that you’re not eligible for a loan with your current details.
                        To secure a loan with us, please start a new application with different details.</div>
                    <button class="btn-theme" (click)="discardLoan()">Start a New Application</button>
                </div>
            </div>
        </div>

    </p-dialog>
</div>